import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SkeletonComponent } from './skeleton.component';

@Component({
  selector: 'fz-skeleton-table',
  template: `
    <fz-skeleton
      width="{1500}"
      height="{280}"
      viewBox="0 0 1500 280"
      backgroundColor="color-mix(in srgb, var(--sys-on-surface) 10%, transparent)"
      foregroundColor="color-mix(in srgb, var(--sys-surface) 10%, transparent)"
    >
      <svg:rect x="0" y="0" rx="4" ry="4" width="20" height="20" />
      <svg:rect x="40" y="1" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="161" y="2" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="375" y="1" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="496" y="2" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="704" y="0" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="825" y="-1" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1397" y="-2" rx="10" ry="10" width="68" height="19" />
      <svg:rect x="0" y="57" rx="4" ry="4" width="20" height="20" />
      <svg:rect x="40" y="58" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="161" y="59" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="375" y="58" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="496" y="59" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="704" y="57" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="825" y="56" rx="10" ry="10" width="85" height="19" />
      <svg:circle cx="1429" cy="64" r="12" />
      <svg:rect x="0" y="119" rx="4" ry="4" width="20" height="20" />
      <svg:rect x="40" y="120" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="161" y="121" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="375" y="120" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="496" y="121" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="704" y="119" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="825" y="118" rx="10" ry="10" width="85" height="19" />
      <svg:circle cx="1429" cy="126" r="12" />
      <svg:rect x="0" y="177" rx="4" ry="4" width="20" height="20" />
      <svg:rect x="40" y="178" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="161" y="179" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="375" y="178" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="496" y="179" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="704" y="177" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="825" y="176" rx="10" ry="10" width="85" height="19" />
      <svg:circle cx="1429" cy="184" r="12" />
      <svg:rect x="0" y="240" rx="4" ry="4" width="20" height="20" />
      <svg:rect x="40" y="241" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="161" y="242" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="375" y="241" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="496" y="242" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="704" y="240" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="825" y="239" rx="10" ry="10" width="85" height="19" />
      <svg:circle cx="1429" cy="247" r="12" />
      <svg:rect x="951" y="0" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="950" y="57" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="950" y="119" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="950" y="177" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="950" y="240" rx="10" ry="10" width="169" height="19" />
      <svg:rect x="1156" y="1" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1155" y="58" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1155" y="120" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1155" y="178" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1155" y="241" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1278" y="-2" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1277" y="55" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1277" y="117" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1277" y="175" rx="10" ry="10" width="85" height="19" />
      <svg:rect x="1277" y="238" rx="10" ry="10" width="85" height="19" />
    </fz-skeleton>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonTableComponent extends SkeletonComponent {}
